'use strict';

import { createJSWorkletsModule } from './JSWorklets';

export const WorkletsModule = createJSWorkletsModule();
